// CarnivalFormDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CarnivalFormDialog = ({
  open,
  onClose,
  formData,
  setFormData,
  onSubmit,
  mode = "create",
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx:
          mode === "edit"
            ? {
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.00)",
                backgroundColor: "#fff",
              }
            : {},
      }}
      sx={
        mode === "edit"
          ? {
              "& .MuiBackdrop-root": {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
              },
            }
          : {}
      }
    >
      <DialogTitle>
        {mode === "create" ? t("carnivals.createNew") : t("carnivals.editCaravan")}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          label={t("carnivals.caravanTitle")}
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          label={t("carnivals.caravanDescription")}
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          label={t("carnivals.maxParticipantsLabel")}
          type="number"
          inputProps={{ min: 1 }}
          value={formData.max_participants}
          onChange={(e) =>
            setFormData({ ...formData, max_participants: e.target.value })
          }
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          label={t("carnivals.deadlineLabel")}
          type="datetime-local"
          value={formData.deadline}
          onChange={(e) =>
            setFormData({ ...formData, deadline: e.target.value })
          }
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          label={t("carnivals.startTimeLabel")}
          type="datetime-local"
          value={formData.start_time}
          onChange={(e) =>
            setFormData({ ...formData, start_time: e.target.value })
          }
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: "#64748b",
            "&:hover": {
              backgroundColor: "rgba(100, 116, 139, 0.04)",
            },
          }}
        >
          {t("carnivals.cancel")}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={!formData.title || !formData.deadline}
          sx={{
            background: "linear-gradient(45deg, #0017E7 30%, #1e40af 90%)",
            "&:hover": {
              background: "linear-gradient(45deg, #0010a3 30%, #1e3a8a 90%)",
              transform: "translateY(-1px)",
            },
            "&:disabled": {
              background: "#e2e8f0",
              color: "#94a3b8",
            },
            transition: "all 0.2s ease-in-out",
          }}
        >
          {mode === "create" ? t("carnivals.createCaravan") : t("carnivals.saveChanges")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CarnivalFormDialog;
